import React, { useState, useEffect, useCallback } from 'react';
import { Result, Spin, Button } from 'antd';
import { useParams } from 'react-router-dom'; // If using React Router
import { useTranslation } from 'react-i18next';
import { verifyEmail } from './EmailVerificationServices';
import { basename } from '../../Constants/env';

const EmailVerificationPage = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const [verified, setVerified] = useState(false);
    const [error, setError] = useState('');
    const { token } = useParams();

    const verifyEmailCall = useCallback(async () => {
        try {
            if (!token) {
                throw new Error(t('no_verification_token_found'));
            }
            const response = await verifyEmail(token);
            if (response.success) {
                setVerified(true);
            } else {
                setError(response.message || t('verification_failed'));
            }
        } catch (err) {
            setError(err.response?.data?.message || err.message || t('verification_failed'));
        } finally {
            setLoading(false);
        }
    }, [token, t]);

    useEffect(() => {
        verifyEmailCall();
    }, [verifyEmailCall]);

    if (loading) {
        return (
            <div style={{ textAlign: 'center', marginTop: 100 }}>
                <Spin size="large" />
                <p>{t('loading')}</p>
            </div>
        );
    }

    if (verified) {
        return (
            <div style={{ maxWidth: 800, margin: '100px auto' }}>
                <Result
                    status="success"
                    title={t('email_verified_successfully')}
                    subTitle={t('your_email_address_has_been_successfully_verified')}
                    extra={[
                        <Button type="primary" key="home" href={basename + "/"}>
                            {t('go_to_home')}
                        </Button>
                    ]}
                />
            </div>
        );
    }

    return (
        <div style={{ maxWidth: 800, margin: '100px auto' }}>
            <Result
                status="error"
                title={t('email_verification_failed')}
                subTitle={error}
                extra={[
                    <Button key="home" href={basename + "/"}>
                        {t('go_to_home')}
                    </Button>
                ]}
            />
        </div>
    );
};

export default EmailVerificationPage;
